import React, { useEffect, useState, Fragment, useRef } from 'react';
import {  PageHeader } from '../../../Common';
import services from '../services';
import $ from 'jquery';
import authService from '../../Common/services';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Joi from '@hapi/joi'
import { AttendanceReportDailySchemaObject } from '../AttendanceReportDailySchema';
import { validateProperty, validate } from "../../Common";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = 'ATTENDANCEREPORTDAILY';

export function AttendanceReportDaily(props) {

    const componentRef = useRef();
    const [groups, setGroups] = useState([]);
    const [operationEntities, setOperationEntities] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [operationEntityType, setOperationEntityType] = useState(0);
    const [errors, setErrors] = useState({})
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false
    });
    const [istableHidden, setIstableHidden] = useState(true);
    const [attendance, setAttendance] = useState([]);
    const csvHeaders = [
        { label: "Registration Number", value: "registrationNumber" },
        { label: "First name", value: "firstName" },
        { label: "In Time", value: "Intime3" },
        { label: "Out Time", value: "Outtime3" },
    ];

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    const [DailyAttendance, setDailyAttendance] = useState({
        groupID: '0',
        operationEntityID: '0',
        divisionID: '0',
        date: "",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        operationEntity: "0",
        division: "0",
        date: "",
    })

    const schema = Joi.object(AttendanceReportDailySchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getAllGroups();
    }, []);

    useEffect(() => {
        if (DailyAttendance.groupID != 0 || DailyAttendance.groupID != "") {
            getOperationEntitiesForDropdown();
        }
    }, [DailyAttendance.groupID]);

    useEffect(() => {
        if (DailyAttendance.operationEntityID !== '0') {
            GetOperationEntityType();
            getDivisionsForDropdown();
        }
    }, [DailyAttendance.operationEntityID]);

    function handleGroupChange(target) {
        validateInputs(target);
        setDailyAttendance({
            ...DailyAttendance,
            groupID: target.value,
            operationEntityID: '0',
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);
        setDailyAttendance({
            ...DailyAttendance,
            operationEntityID: target.value,
        })
    }

    function handleDivisionChange(target) {
        validateInputs(target);
        setDailyAttendance({
            ...DailyAttendance,
            divisionID: target.value,
        })
    }

    function handleDateChange(target) {
        validateInputs(target);
        setDailyAttendance({
            ...DailyAttendance,
            date: target.value
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, AttendanceReportDailySchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWATTENDANCEREPORTDAILY');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        getAllGroups();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    async function getAllGroups() {
        var data
        data = await groupService.getGroupsForDropdown();
        setGroups(data)
    }

    async function getOperationEntitiesForDropdown() {
        var data
        data = await services.getOperationEntitiesByGroupID(DailyAttendance.groupID);
        setOperationEntities(data)
    }

    async function getDivisionsForDropdown() {
        var data
        data = await services.getDivisionsByOperationEntityID(DailyAttendance.operationEntityID);
        setDivisions(data)
    }

    async function GetOperationEntityType() {
        var data = await services.GetEntityTypeByOperationEntityID(DailyAttendance.operationEntityID , DailyAttendance.groupID);
        if (data.length != 0) {
            setOperationEntityType(data[0])
        }
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    async function handleView(e) {
        e.preventDefault();
        const errorMessages = validate(schema, DailyAttendance);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        getSelectedDropdownValuesForReport(DailyAttendance);
        const response = await services.getAttendanceReportDaily(DailyAttendance);
        setIstableHidden(false);
        destroyDataTable();
        setAttendance(response);
        createDataTable();
    }

    function onCancelClick() {
        setDailyAttendance({
            ...DailyAttendance,
            operationEntityID: "0",
        });
        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setDailyAttendance([]);
        setIstableHidden(true);
        setSelectedSearchValues([]);
    }

    attendance.forEach(x => {
        x.Intime = x.inTime.split('.');
        x.Intime2 = x.Intime[0]
        x.Intime3 = x.Intime2 == '- - -' ? '- - -' : (x.Intime2 >= "12" ? x.Intime2 + " PM" : x.Intime2 + " AM")
        x.Outtime = x.outTime.split('.');
        x.Outtime2 = x.Outtime[0]
        x.Outtime3 = x.Outtime2 == '- - -' ? '- - -' : (x.Outtime2 >= "12" ? x.Outtime2 + " PM" : x.Outtime2 + " AM")
    })

    function createFile() {
        var settings = {
            sheetName: 'Attendence Report Daily',
            fileName: 'AttendenceReportDaily',
            writeOptions: {}
        }

        var copyOfCsv = _.cloneDeep(attendance)

        var newRow1 = {
            registrationNumber: "Group :" + groups[DailyAttendance.groupID],
            firstName: "Operation Entity : " + operationEntities[DailyAttendance.operationEntityID]
        }
        var newRow2 = {
            registrationNumber: "Division : " + divisions[DailyAttendance.divisionID],
            firstName: "Date : " + DailyAttendance.date,
        }
        copyOfCsv.push({}, {}, newRow1, newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntities[searchForm.operationEntityID],
            division: divisions[searchForm.divisionID],
            date: searchForm.date,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Attendance Daily Report"
                            isButtonEnable={permissionList.isAddEditEnabled} //
                            buttonText="Add Groups"                      
                            path="groups/addEdit" />                        
                        <div className="card-body">
                            <form>    
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={DailyAttendance.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={DailyAttendance.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntities)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="divisionID">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={DailyAttendance.divisionID}
                                            disabled={operationEntityType.enityTypeID != 2}
                                            onChange={(e) => handleDivisionChange(e.target)}>
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && <FormHelperText error>{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-6 ">
                                        <InputLabel shrink id="date">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && <FormHelperText error>{errors["date"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, DailyAttendance)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleView(e))}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            {attendance.length != 0 ?
                                <div style={{ width: '1400px' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="simple table" hidden={istableHidden}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Registration Number</TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Employee Name
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        In time
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                                        Out time
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {attendance.map((row) => (
                                                                    <TableRow key={row.employeeCode}>
                                                                        <TableCell component="th" scope="row">
                                                                            {row.registrationNumber}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {row.firstName}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {row.Intime3}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row">
                                                                            {row.Outtime3}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                        {attendance.length != 0 ?
                            <div className="pt-2">
                                <ReactToPrint
                                    trigger={() => <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="PDF"
                                    />}
                                    content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                    <CreatePdf
                                        ref={componentRef} attendance={attendance}
                                        searchData={selectedSearchValues}
                                    />
                                </div>
                                <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Excel"
                                    onClick={createFile}
                                />
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


